import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Leaf, Printer } from "lucide-react";
import { http } from "@/lib/api";
import { BRAND } from "@/lib/brand";

export default function Certificate() {
  const { certId } = useParams();
  const [c, setC] = useState(undefined);
  useEffect(() => { http.get(`/public/certificates/${certId}`).then((r) => setC(r.data)).catch(() => setC(null)); }, [certId]);
  if (c === undefined) return <div className="max-w-4xl mx-auto px-6 py-20 text-stone-500">Loading…</div>;
  if (!c) return <div className="max-w-4xl mx-auto px-6 py-20 text-stone-600" data-testid="certificate-not-found">Certificate not found.</div>;
  const date = new Date(c.issued_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  return (
    <div className="max-w-4xl mx-auto px-6 py-12" data-testid="certificate-page">
      <button onClick={() => window.print()} data-testid="certificate-print-btn" className="no-print mb-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#E6DEC3] text-sm text-[#2C4A3E]"><Printer className="w-4 h-4" /> Print certificate</button>
      <div className="relative rounded-[2rem] bg-[#FDFBF7] border-[10px] border-double border-[#C87D53] p-10 sm:p-16 text-center shadow-xl">
        <span className="w-14 h-14 mx-auto rounded-full bg-[#2C4A3E] grid place-items-center"><Leaf className="w-6 h-6 text-[#F7F3EB]" /></span>
        <p className="mt-6 text-xs uppercase tracking-[0.35em] text-[#C87D53] font-semibold">Certificate of Completion</p>
        <p className="mt-8 text-stone-500">This certifies that</p>
        <h1 className="font-display text-4xl sm:text-6xl text-[#2C4A3E] mt-3" data-testid="certificate-name">{c.name}</h1>
        <p className="mt-6 text-stone-600 max-w-xl mx-auto">has completed all eight modules of the <b>{c.program}</b> and written a complete personal business plan, discovering how their own gifts can serve their community.</p>
        <div className="mt-12 grid grid-cols-2 gap-8 text-sm text-stone-600 max-w-lg mx-auto">
          <div className="border-t border-stone-300 pt-2">{date}<br /><span className="text-xs text-stone-400">Date issued</span></div>
          <div className="border-t border-stone-300 pt-2">{BRAND} · {c.state}<br /><span className="text-xs text-stone-400">Issued by</span></div>
        </div>
        <p className="mt-10 text-[11px] text-stone-400" data-testid="certificate-id">Verify at {window.location.origin}/certificate/{c.id} · ID {c.id}</p>
      </div>
    </div>
  );
}
